import React from 'react';
import styles from './PlanDetailHeader.module.css';

interface PlanDetailHeaderProps {
    title: string;
    subtitle?: string;
    actions?: React.ReactNode;
}

const PlanDetailHeader: React.FC<PlanDetailHeaderProps> = ({ title, subtitle, actions }) => {
    return (
        <header className={styles.header}>
            <div className={styles.inner}>
                <div className={styles.text}>
                    <h1 className={styles.title}>{title}</h1>
                    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                </div>
                {actions && <div className={styles.actions}>{actions}</div>}
            </div>
        </header>
    );
};

export default PlanDetailHeader;
